
    <!--
 * 页面-游戏-390
 * @LastEditTime: Mon Mar 31 2025 16:34:12 GMT+0800 (中国标准时间)
 -->
 <template>
  <div id="u_c_L26018"  v-if="pageData.gameId ? pageData.gameId == compData.gameId : pageData.previewGameId == compData.gameId" :class="[`normal`,`u_c_L26018`]" ><div id="u_c_TUAY19"  :class="[`normal `,`u_c_TUAY19`]" ><div id="u_c_K0IK20"  :style="`color:${ pageData.linkTxtColor }`" :class="[`normal step`,`u_c_K0IK20`]" >{{`${ compData.step1Txt }`}}</div><img id="u_c_FAAB22"  :src="compData.step1Img" v-show="compData.step1Img" :class="[`normal step-img`,`u_c_FAAB22`]" /></div><div id="u_c_OAV423"  :class="[`normal`,`u_c_OAV423`]" ><div id="u_c_F6N624"  :style="`color:${ pageData.linkTxtColor }`" :class="[`normal step`,`u_c_F6N624`]" >{{`${ langData.getStep2 }`}}</div><div id="u_c_OPMA26"  :class="[`normal`,`u_c_OPMA26`]" ><img id="u_c_MMUV27"  :src="pageData.hostInfo[pageData.curHost].step2" :class="[`normal step-img`,`u_c_MMUV27`]" /><div id="u_c_EK0K28"  :class="[`normal`,`u_c_EK0K28`]" >{{`${ langData.tokenKey }`}}</div></div></div><div id="u_c_OXQE30"  :class="[`normal`,`u_c_OXQE30`]" ><div id="u_c_K8EC31"  :style="`color:${ pageData.linkTxtColor }`" :class="[`normal step`,`u_c_K8EC31`]" >{{`${ langData.getStep3 }`}}</div><div id="u_c_IPV333"  :class="[`normal step-img`,`u_c_IPV333`]" ><img id="u_c_K0GA34"  :src="`https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/08/16608043509764.png`" :class="[`normal`,`u_c_K0GA34`]" /><div id="u_c_OQIZ35"  :style="`color:${ pageData.hostInfo[pageData.curHost].titleColor }`" :class="[`normal`,`u_c_OQIZ35`]" >{{`${ langData.tokenKey }`}}</div></div></div></div>
  </template>
<script setup>
import {reactive,provide,inject,onMounted,watch,watchEffect,ref,computed,nextTick,readonly,toRaw,markRaw} from "vue";
import * as vueUse from "@vueuse/core";
import Language from "@/hooks/language.js";
import Router from "@/hooks/router.js";
import bridge from "@/utils/sdkBridge.js";
import { useRoute } from 'vue-router';
import * as request from "@/api/request";
import * as utils from "@/utils";
import * as _ from "lodash-es";


    const { curLang, getLangTxt,langData } = Language();
    const routerData = inject("routerData",{});
    const pageData = inject("pageData", {});
    const COMP_DATA_LANG = {"default":{"gameId":390,"step1Txt":`Step 1: Go to Settings > Account > User Center`,"step1Img":`https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/09/1726825530362-99.png`},"zh-CN":{"gameId":390,"step1Txt":`Step1:点击设置-账户-用户中心`,"step1Img":`https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/09/1726825530362-99.png`},"zh-TW":{"gameId":390,"step1Txt":`Step1:點擊設置-帳戶-用戶中心`,"step1Img":`https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/09/1726825530362-99.png`},"en-US":{"gameId":390,"step1Txt":`Step 1: Go to Settings > Account > User Center`,"step1Img":`https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/09/1726825530362-99.png`},"ja-JP":{"gameId":390,"step1Txt":`Step1:設定-アカウント-マイページ`,"step1Img":`https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/09/1726825530362-99.png`},"ko-KR":{"gameId":390,"step1Txt":`Step1:설정 - 계정 - 유저 센터를 터치합니다.`,"step1Img":`https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/09/1726825530362-99.png`},"th-TH":{"gameId":390,"step1Txt":`Step1 : เลือกตั้งค่า-บัญชี-ศูนย์ผู้ใช้งาน`,"step1Img":`https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/09/1726825530362-99.png`},"vi-VN":{"gameId":390,"step1Txt":`Step1: Nhấp vào Thiết lập- Tài khoản- Trung Tâm Người Dùng`,"step1Img":`https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/09/1726825530362-99.png`},"de-DE":{"gameId":390,"step1Txt":`Schritt 1: Geh zu Einstellung > Konto > Benutzer Zentrum.`,"step1Img":`https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/09/1726825530362-99.png`},"fr-FR":{"gameId":390,"step1Txt":`Étape 1 : Allez dans Paramètres > Compte > Centre d'utilisateur`,"step1Img":`https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/09/1726825530362-99.png`},"ru-RU":{"gameId":390,"step1Txt":`Шаг 1: Нажмите «Настройки» - «Аккаунт» - «Центр Пользователя»`,"step1Img":`https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/09/1726825530362-99.png`},"es-ES":{"gameId":390,"step1Txt":`Paso 1: Ve a Ajustes > Cuenta > Centro del usuario`,"step1Img":`https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/09/1726825530362-99.png`},"pt-PT":{"gameId":390,"step1Txt":`Step 1: Go to Settings > Account > User Center`,"step1Img":`https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/09/1726825530362-99.png`},"it-IT":{"gameId":390,"step1Txt":`Passaggio 1: vai su Impostazioni > Account > Centro Utenti`,"step1Img":`https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/09/1726825530362-99.png`},"tr-TR":{"gameId":390,"step1Txt":`Adım 1: Ayarlar > Hesap > Kullanıcı Merkezi`,"step1Img":`https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/09/1726825530362-99.png`},"pl-PL":{"gameId":390,"step1Txt":`Step 1: Go to Settings > Account > User Center`,"step1Img":`https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/09/1726825530362-99.png`},"id-ID":{"gameId":390,"step1Txt":`Step 1: Go to Settings > Account > User Center`,"step1Img":`https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/09/1726825530362-99.png`},"ar-SA":{"gameId":390,"step1Txt":`الخطوة 1: اضغط على الإعدادات - الحساب - مركز المستخدم`,"step1Img":`https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/09/1726825530362-99.png`}};
    const compData = reactive(COMP_DATA_LANG[curLang] || COMP_DATA_LANG['en-US']||{});
    let pagePlatform = "global"
    const router = Router();
    const route = useRoute();
    const compName = '游戏-390';

    // 自定义setup - 开始
    ;
    // 自定义setup - 结束


</script>
<style lang="scss" scoped>
.default{
.u_c_L26018.normal{
position:relative;

}

.u_c_L26018.normal .step{
font-size:3.20vw;
color:#707070;

}

.u_c_L26018.normal .step-img{
display:block;
margin:2.00vw auto 5.33vw;
max-width:100%;
border:1.33vw solid white;
box-shadow:0px 2px 5px rgba(0,0,0,0.4);

}
}.default{
.u_c_TUAY19.normal{
position:relative;

}
}.default{
.u_c_K0IK20.normal{
position:relative;

}
}.default{
.u_c_FAAB22.normal{
position:relative;

}
}.default{
.u_c_OAV423.normal{
position:relative;

}
}.default{
.u_c_F6N624.normal{
position:relative;

}
}.default{
.u_c_OPMA26.normal{
position:relative;

}
}.default{
.u_c_MMUV27.normal{
position:relative;
width:100%;

}
}.default{
.u_c_EK0K28.normal{
position:absolute;
font-size:3.47vw;
color:#444;
bottom:6.00vw;
left:12.80vw;
font-weight:bold;

}
}.default{
.u_c_OXQE30.normal{
position:relative;

}
}.default{
.u_c_K8EC31.normal{
position:relative;

}
}.default{
.u_c_IPV333.normal{
position:relative;
width:100%;
background-color:white;

}
}.default{
.u_c_K0GA34.normal{
position:relative;
width:100%;

}
}.default{
.u_c_OQIZ35.normal{
position:absolute;
font-size:3.20vw;
top:2.67vw;
left:2.67vw;
font-weight:bold;

}
}.zh-CN{
.u_c_L26018.normal{
position:relative;

}

.u_c_L26018.normal .step{
font-size:3.20vw;
color:#707070;

}

.u_c_L26018.normal .step-img{
display:block;
margin:2.00vw auto 5.33vw;
max-width:100%;
border:1.33vw solid white;
box-shadow:0px 2px 5px rgba(0,0,0,0.4);

}
}.zh-CN{
.u_c_TUAY19.normal{
position:relative;

}
}.zh-CN{
.u_c_K0IK20.normal{
position:relative;

}
}.zh-CN{
.u_c_FAAB22.normal{
position:relative;

}
}.zh-CN{
.u_c_OAV423.normal{
position:relative;

}
}.zh-CN{
.u_c_F6N624.normal{
position:relative;

}
}.zh-CN{
.u_c_OPMA26.normal{
position:relative;

}
}.zh-CN{
.u_c_MMUV27.normal{
position:relative;
width:100%;

}
}.zh-CN{
.u_c_EK0K28.normal{
position:absolute;
font-size:3.47vw;
color:#444;
bottom:6.00vw;
left:12.80vw;
font-weight:bold;

}
}.zh-CN{
.u_c_OXQE30.normal{
position:relative;

}
}.zh-CN{
.u_c_K8EC31.normal{
position:relative;

}
}.zh-CN{
.u_c_IPV333.normal{
position:relative;
width:100%;
background-color:white;

}
}.zh-CN{
.u_c_K0GA34.normal{
position:relative;
width:100%;

}
}.zh-CN{
.u_c_OQIZ35.normal{
position:absolute;
font-size:3.20vw;
top:2.67vw;
left:2.67vw;
font-weight:bold;

}
}.zh-TW{
.u_c_L26018.normal{
position:relative;

}

.u_c_L26018.normal .step{
font-size:3.20vw;
color:#707070;

}

.u_c_L26018.normal .step-img{
display:block;
margin:2.00vw auto 5.33vw;
max-width:100%;
border:1.33vw solid white;
box-shadow:0px 2px 5px rgba(0,0,0,0.4);

}
}.zh-TW{
.u_c_TUAY19.normal{
position:relative;

}
}.zh-TW{
.u_c_K0IK20.normal{
position:relative;

}
}.zh-TW{
.u_c_FAAB22.normal{
position:relative;

}
}.zh-TW{
.u_c_OAV423.normal{
position:relative;

}
}.zh-TW{
.u_c_F6N624.normal{
position:relative;

}
}.zh-TW{
.u_c_OPMA26.normal{
position:relative;

}
}.zh-TW{
.u_c_MMUV27.normal{
position:relative;
width:100%;

}
}.zh-TW{
.u_c_EK0K28.normal{
position:absolute;
font-size:3.47vw;
color:#444;
bottom:6.00vw;
left:12.80vw;
font-weight:bold;

}
}.zh-TW{
.u_c_OXQE30.normal{
position:relative;

}
}.zh-TW{
.u_c_K8EC31.normal{
position:relative;

}
}.zh-TW{
.u_c_IPV333.normal{
position:relative;
width:100%;
background-color:white;

}
}.zh-TW{
.u_c_K0GA34.normal{
position:relative;
width:100%;

}
}.zh-TW{
.u_c_OQIZ35.normal{
position:absolute;
font-size:3.20vw;
top:2.67vw;
left:2.67vw;
font-weight:bold;

}
}.en-US{
.u_c_L26018.normal{
position:relative;

}

.u_c_L26018.normal .step{
font-size:3.20vw;
color:#707070;

}

.u_c_L26018.normal .step-img{
display:block;
margin:2.00vw auto 5.33vw;
max-width:100%;
border:1.33vw solid white;
box-shadow:0px 2px 5px rgba(0,0,0,0.4);

}
}.en-US{
.u_c_TUAY19.normal{
position:relative;

}
}.en-US{
.u_c_K0IK20.normal{
position:relative;

}
}.en-US{
.u_c_FAAB22.normal{
position:relative;

}
}.en-US{
.u_c_OAV423.normal{
position:relative;

}
}.en-US{
.u_c_F6N624.normal{
position:relative;

}
}.en-US{
.u_c_OPMA26.normal{
position:relative;

}
}.en-US{
.u_c_MMUV27.normal{
position:relative;
width:100%;

}
}.en-US{
.u_c_EK0K28.normal{
position:absolute;
font-size:3.47vw;
color:#444;
bottom:6.00vw;
left:12.80vw;
font-weight:bold;

}
}.en-US{
.u_c_OXQE30.normal{
position:relative;

}
}.en-US{
.u_c_K8EC31.normal{
position:relative;

}
}.en-US{
.u_c_IPV333.normal{
position:relative;
width:100%;
background-color:white;

}
}.en-US{
.u_c_K0GA34.normal{
position:relative;
width:100%;

}
}.en-US{
.u_c_OQIZ35.normal{
position:absolute;
font-size:3.20vw;
top:2.67vw;
left:2.67vw;
font-weight:bold;

}
}.ja-JP{
.u_c_L26018.normal{
position:relative;

}

.u_c_L26018.normal .step{
font-size:3.20vw;
color:#707070;

}

.u_c_L26018.normal .step-img{
display:block;
margin:2.00vw auto 5.33vw;
max-width:100%;
border:1.33vw solid white;
box-shadow:0px 2px 5px rgba(0,0,0,0.4);

}
}.ja-JP{
.u_c_TUAY19.normal{
position:relative;

}
}.ja-JP{
.u_c_K0IK20.normal{
position:relative;

}
}.ja-JP{
.u_c_FAAB22.normal{
position:relative;

}
}.ja-JP{
.u_c_OAV423.normal{
position:relative;

}
}.ja-JP{
.u_c_F6N624.normal{
position:relative;

}
}.ja-JP{
.u_c_OPMA26.normal{
position:relative;

}
}.ja-JP{
.u_c_MMUV27.normal{
position:relative;
width:100%;

}
}.ja-JP{
.u_c_EK0K28.normal{
position:absolute;
font-size:3.47vw;
color:#444;
bottom:6.00vw;
left:12.80vw;
font-weight:bold;

}
}.ja-JP{
.u_c_OXQE30.normal{
position:relative;

}
}.ja-JP{
.u_c_K8EC31.normal{
position:relative;

}
}.ja-JP{
.u_c_IPV333.normal{
position:relative;
width:100%;
background-color:white;

}
}.ja-JP{
.u_c_K0GA34.normal{
position:relative;
width:100%;

}
}.ja-JP{
.u_c_OQIZ35.normal{
position:absolute;
font-size:3.20vw;
top:2.67vw;
left:2.67vw;
font-weight:bold;

}
}.ko-KR{
.u_c_L26018.normal{
position:relative;

}

.u_c_L26018.normal .step{
font-size:3.20vw;
color:#707070;

}

.u_c_L26018.normal .step-img{
display:block;
margin:2.00vw auto 5.33vw;
max-width:100%;
border:1.33vw solid white;
box-shadow:0px 2px 5px rgba(0,0,0,0.4);

}
}.ko-KR{
.u_c_TUAY19.normal{
position:relative;

}
}.ko-KR{
.u_c_K0IK20.normal{
position:relative;

}
}.ko-KR{
.u_c_FAAB22.normal{
position:relative;

}
}.ko-KR{
.u_c_OAV423.normal{
position:relative;

}
}.ko-KR{
.u_c_F6N624.normal{
position:relative;

}
}.ko-KR{
.u_c_OPMA26.normal{
position:relative;

}
}.ko-KR{
.u_c_MMUV27.normal{
position:relative;
width:100%;

}
}.ko-KR{
.u_c_EK0K28.normal{
position:absolute;
font-size:3.47vw;
color:#444;
bottom:6.00vw;
left:12.80vw;
font-weight:bold;

}
}.ko-KR{
.u_c_OXQE30.normal{
position:relative;

}
}.ko-KR{
.u_c_K8EC31.normal{
position:relative;

}
}.ko-KR{
.u_c_IPV333.normal{
position:relative;
width:100%;
background-color:white;

}
}.ko-KR{
.u_c_K0GA34.normal{
position:relative;
width:100%;

}
}.ko-KR{
.u_c_OQIZ35.normal{
position:absolute;
font-size:3.20vw;
top:2.67vw;
left:2.67vw;
font-weight:bold;

}
}.th-TH{
.u_c_L26018.normal{
position:relative;

}

.u_c_L26018.normal .step{
font-size:3.20vw;
color:#707070;

}

.u_c_L26018.normal .step-img{
display:block;
margin:2.00vw auto 5.33vw;
max-width:100%;
border:1.33vw solid white;
box-shadow:0px 2px 5px rgba(0,0,0,0.4);

}
}.th-TH{
.u_c_TUAY19.normal{
position:relative;

}
}.th-TH{
.u_c_K0IK20.normal{
position:relative;

}
}.th-TH{
.u_c_FAAB22.normal{
position:relative;

}
}.th-TH{
.u_c_OAV423.normal{
position:relative;

}
}.th-TH{
.u_c_F6N624.normal{
position:relative;

}
}.th-TH{
.u_c_OPMA26.normal{
position:relative;

}
}.th-TH{
.u_c_MMUV27.normal{
position:relative;
width:100%;

}
}.th-TH{
.u_c_EK0K28.normal{
position:absolute;
font-size:3.47vw;
color:#444;
bottom:6.00vw;
left:12.80vw;
font-weight:bold;

}
}.th-TH{
.u_c_OXQE30.normal{
position:relative;

}
}.th-TH{
.u_c_K8EC31.normal{
position:relative;

}
}.th-TH{
.u_c_IPV333.normal{
position:relative;
width:100%;
background-color:white;

}
}.th-TH{
.u_c_K0GA34.normal{
position:relative;
width:100%;

}
}.th-TH{
.u_c_OQIZ35.normal{
position:absolute;
font-size:3.20vw;
top:2.67vw;
left:2.67vw;
font-weight:bold;

}
}.vi-VN{
.u_c_L26018.normal{
position:relative;

}

.u_c_L26018.normal .step{
font-size:3.20vw;
color:#707070;

}

.u_c_L26018.normal .step-img{
display:block;
margin:2.00vw auto 5.33vw;
max-width:100%;
border:1.33vw solid white;
box-shadow:0px 2px 5px rgba(0,0,0,0.4);

}
}.vi-VN{
.u_c_TUAY19.normal{
position:relative;

}
}.vi-VN{
.u_c_K0IK20.normal{
position:relative;

}
}.vi-VN{
.u_c_FAAB22.normal{
position:relative;

}
}.vi-VN{
.u_c_OAV423.normal{
position:relative;

}
}.vi-VN{
.u_c_F6N624.normal{
position:relative;

}
}.vi-VN{
.u_c_OPMA26.normal{
position:relative;

}
}.vi-VN{
.u_c_MMUV27.normal{
position:relative;
width:100%;

}
}.vi-VN{
.u_c_EK0K28.normal{
position:absolute;
font-size:3.47vw;
color:#444;
bottom:6.00vw;
left:12.80vw;
font-weight:bold;

}
}.vi-VN{
.u_c_OXQE30.normal{
position:relative;

}
}.vi-VN{
.u_c_K8EC31.normal{
position:relative;

}
}.vi-VN{
.u_c_IPV333.normal{
position:relative;
width:100%;
background-color:white;

}
}.vi-VN{
.u_c_K0GA34.normal{
position:relative;
width:100%;

}
}.vi-VN{
.u_c_OQIZ35.normal{
position:absolute;
font-size:3.20vw;
top:2.67vw;
left:2.67vw;
font-weight:bold;

}
}.de-DE{
.u_c_L26018.normal{
position:relative;

}

.u_c_L26018.normal .step{
font-size:3.20vw;
color:#707070;

}

.u_c_L26018.normal .step-img{
display:block;
margin:2.00vw auto 5.33vw;
max-width:100%;
border:1.33vw solid white;
box-shadow:0px 2px 5px rgba(0,0,0,0.4);

}
}.de-DE{
.u_c_TUAY19.normal{
position:relative;

}
}.de-DE{
.u_c_K0IK20.normal{
position:relative;

}
}.de-DE{
.u_c_FAAB22.normal{
position:relative;

}
}.de-DE{
.u_c_OAV423.normal{
position:relative;

}
}.de-DE{
.u_c_F6N624.normal{
position:relative;

}
}.de-DE{
.u_c_OPMA26.normal{
position:relative;

}
}.de-DE{
.u_c_MMUV27.normal{
position:relative;
width:100%;

}
}.de-DE{
.u_c_EK0K28.normal{
position:absolute;
font-size:3.47vw;
color:#444;
bottom:6.00vw;
left:12.80vw;
font-weight:bold;

}
}.de-DE{
.u_c_OXQE30.normal{
position:relative;

}
}.de-DE{
.u_c_K8EC31.normal{
position:relative;

}
}.de-DE{
.u_c_IPV333.normal{
position:relative;
width:100%;
background-color:white;

}
}.de-DE{
.u_c_K0GA34.normal{
position:relative;
width:100%;

}
}.de-DE{
.u_c_OQIZ35.normal{
position:absolute;
font-size:3.20vw;
top:2.67vw;
left:2.67vw;
font-weight:bold;

}
}.fr-FR{
.u_c_L26018.normal{
position:relative;

}

.u_c_L26018.normal .step{
font-size:3.20vw;
color:#707070;

}

.u_c_L26018.normal .step-img{
display:block;
margin:2.00vw auto 5.33vw;
max-width:100%;
border:1.33vw solid white;
box-shadow:0px 2px 5px rgba(0,0,0,0.4);

}
}.fr-FR{
.u_c_TUAY19.normal{
position:relative;

}
}.fr-FR{
.u_c_K0IK20.normal{
position:relative;

}
}.fr-FR{
.u_c_FAAB22.normal{
position:relative;

}
}.fr-FR{
.u_c_OAV423.normal{
position:relative;

}
}.fr-FR{
.u_c_F6N624.normal{
position:relative;

}
}.fr-FR{
.u_c_OPMA26.normal{
position:relative;

}
}.fr-FR{
.u_c_MMUV27.normal{
position:relative;
width:100%;

}
}.fr-FR{
.u_c_EK0K28.normal{
position:absolute;
font-size:3.47vw;
color:#444;
bottom:6.00vw;
left:12.80vw;
font-weight:bold;

}
}.fr-FR{
.u_c_OXQE30.normal{
position:relative;

}
}.fr-FR{
.u_c_K8EC31.normal{
position:relative;

}
}.fr-FR{
.u_c_IPV333.normal{
position:relative;
width:100%;
background-color:white;

}
}.fr-FR{
.u_c_K0GA34.normal{
position:relative;
width:100%;

}
}.fr-FR{
.u_c_OQIZ35.normal{
position:absolute;
font-size:3.20vw;
top:2.67vw;
left:2.67vw;
font-weight:bold;

}
}.ru-RU{
.u_c_L26018.normal{
position:relative;

}

.u_c_L26018.normal .step{
font-size:3.20vw;
color:#707070;

}

.u_c_L26018.normal .step-img{
display:block;
margin:2.00vw auto 5.33vw;
max-width:100%;
border:1.33vw solid white;
box-shadow:0px 2px 5px rgba(0,0,0,0.4);

}
}.ru-RU{
.u_c_TUAY19.normal{
position:relative;

}
}.ru-RU{
.u_c_K0IK20.normal{
position:relative;

}
}.ru-RU{
.u_c_FAAB22.normal{
position:relative;

}
}.ru-RU{
.u_c_OAV423.normal{
position:relative;

}
}.ru-RU{
.u_c_F6N624.normal{
position:relative;

}
}.ru-RU{
.u_c_OPMA26.normal{
position:relative;

}
}.ru-RU{
.u_c_MMUV27.normal{
position:relative;
width:100%;

}
}.ru-RU{
.u_c_EK0K28.normal{
position:absolute;
font-size:3.47vw;
color:#444;
bottom:6.00vw;
left:12.80vw;
font-weight:bold;

}
}.ru-RU{
.u_c_OXQE30.normal{
position:relative;

}
}.ru-RU{
.u_c_K8EC31.normal{
position:relative;

}
}.ru-RU{
.u_c_IPV333.normal{
position:relative;
width:100%;
background-color:white;

}
}.ru-RU{
.u_c_K0GA34.normal{
position:relative;
width:100%;

}
}.ru-RU{
.u_c_OQIZ35.normal{
position:absolute;
font-size:3.20vw;
top:2.67vw;
left:2.67vw;
font-weight:bold;

}
}.es-ES{
.u_c_L26018.normal{
position:relative;

}

.u_c_L26018.normal .step{
font-size:3.20vw;
color:#707070;

}

.u_c_L26018.normal .step-img{
display:block;
margin:2.00vw auto 5.33vw;
max-width:100%;
border:1.33vw solid white;
box-shadow:0px 2px 5px rgba(0,0,0,0.4);

}
}.es-ES{
.u_c_TUAY19.normal{
position:relative;

}
}.es-ES{
.u_c_K0IK20.normal{
position:relative;

}
}.es-ES{
.u_c_FAAB22.normal{
position:relative;

}
}.es-ES{
.u_c_OAV423.normal{
position:relative;

}
}.es-ES{
.u_c_F6N624.normal{
position:relative;

}
}.es-ES{
.u_c_OPMA26.normal{
position:relative;

}
}.es-ES{
.u_c_MMUV27.normal{
position:relative;
width:100%;

}
}.es-ES{
.u_c_EK0K28.normal{
position:absolute;
font-size:3.47vw;
color:#444;
bottom:6.00vw;
left:12.80vw;
font-weight:bold;

}
}.es-ES{
.u_c_OXQE30.normal{
position:relative;

}
}.es-ES{
.u_c_K8EC31.normal{
position:relative;

}
}.es-ES{
.u_c_IPV333.normal{
position:relative;
width:100%;
background-color:white;

}
}.es-ES{
.u_c_K0GA34.normal{
position:relative;
width:100%;

}
}.es-ES{
.u_c_OQIZ35.normal{
position:absolute;
font-size:3.20vw;
top:2.67vw;
left:2.67vw;
font-weight:bold;

}
}.pt-PT{
.u_c_L26018.normal{
position:relative;

}

.u_c_L26018.normal .step{
font-size:3.20vw;
color:#707070;

}

.u_c_L26018.normal .step-img{
display:block;
margin:2.00vw auto 5.33vw;
max-width:100%;
border:1.33vw solid white;
box-shadow:0px 2px 5px rgba(0,0,0,0.4);

}
}.pt-PT{
.u_c_TUAY19.normal{
position:relative;

}
}.pt-PT{
.u_c_K0IK20.normal{
position:relative;

}
}.pt-PT{
.u_c_FAAB22.normal{
position:relative;

}
}.pt-PT{
.u_c_OAV423.normal{
position:relative;

}
}.pt-PT{
.u_c_F6N624.normal{
position:relative;

}
}.pt-PT{
.u_c_OPMA26.normal{
position:relative;

}
}.pt-PT{
.u_c_MMUV27.normal{
position:relative;
width:100%;

}
}.pt-PT{
.u_c_EK0K28.normal{
position:absolute;
font-size:3.47vw;
color:#444;
bottom:6.00vw;
left:12.80vw;
font-weight:bold;

}
}.pt-PT{
.u_c_OXQE30.normal{
position:relative;

}
}.pt-PT{
.u_c_K8EC31.normal{
position:relative;

}
}.pt-PT{
.u_c_IPV333.normal{
position:relative;
width:100%;
background-color:white;

}
}.pt-PT{
.u_c_K0GA34.normal{
position:relative;
width:100%;

}
}.pt-PT{
.u_c_OQIZ35.normal{
position:absolute;
font-size:3.20vw;
top:2.67vw;
left:2.67vw;
font-weight:bold;

}
}.it-IT{
.u_c_L26018.normal{
position:relative;

}

.u_c_L26018.normal .step{
font-size:3.20vw;
color:#707070;

}

.u_c_L26018.normal .step-img{
display:block;
margin:2.00vw auto 5.33vw;
max-width:100%;
border:1.33vw solid white;
box-shadow:0px 2px 5px rgba(0,0,0,0.4);

}
}.it-IT{
.u_c_TUAY19.normal{
position:relative;

}
}.it-IT{
.u_c_K0IK20.normal{
position:relative;

}
}.it-IT{
.u_c_FAAB22.normal{
position:relative;

}
}.it-IT{
.u_c_OAV423.normal{
position:relative;

}
}.it-IT{
.u_c_F6N624.normal{
position:relative;

}
}.it-IT{
.u_c_OPMA26.normal{
position:relative;

}
}.it-IT{
.u_c_MMUV27.normal{
position:relative;
width:100%;

}
}.it-IT{
.u_c_EK0K28.normal{
position:absolute;
font-size:3.47vw;
color:#444;
bottom:6.00vw;
left:12.80vw;
font-weight:bold;

}
}.it-IT{
.u_c_OXQE30.normal{
position:relative;

}
}.it-IT{
.u_c_K8EC31.normal{
position:relative;

}
}.it-IT{
.u_c_IPV333.normal{
position:relative;
width:100%;
background-color:white;

}
}.it-IT{
.u_c_K0GA34.normal{
position:relative;
width:100%;

}
}.it-IT{
.u_c_OQIZ35.normal{
position:absolute;
font-size:3.20vw;
top:2.67vw;
left:2.67vw;
font-weight:bold;

}
}.tr-TR{
.u_c_L26018.normal{
position:relative;

}

.u_c_L26018.normal .step{
font-size:3.20vw;
color:#707070;

}

.u_c_L26018.normal .step-img{
display:block;
margin:2.00vw auto 5.33vw;
max-width:100%;
border:1.33vw solid white;
box-shadow:0px 2px 5px rgba(0,0,0,0.4);

}
}.tr-TR{
.u_c_TUAY19.normal{
position:relative;

}
}.tr-TR{
.u_c_K0IK20.normal{
position:relative;

}
}.tr-TR{
.u_c_FAAB22.normal{
position:relative;

}
}.tr-TR{
.u_c_OAV423.normal{
position:relative;

}
}.tr-TR{
.u_c_F6N624.normal{
position:relative;

}
}.tr-TR{
.u_c_OPMA26.normal{
position:relative;

}
}.tr-TR{
.u_c_MMUV27.normal{
position:relative;
width:100%;

}
}.tr-TR{
.u_c_EK0K28.normal{
position:absolute;
font-size:3.47vw;
color:#444;
bottom:6.00vw;
left:12.80vw;
font-weight:bold;

}
}.tr-TR{
.u_c_OXQE30.normal{
position:relative;

}
}.tr-TR{
.u_c_K8EC31.normal{
position:relative;

}
}.tr-TR{
.u_c_IPV333.normal{
position:relative;
width:100%;
background-color:white;

}
}.tr-TR{
.u_c_K0GA34.normal{
position:relative;
width:100%;

}
}.tr-TR{
.u_c_OQIZ35.normal{
position:absolute;
font-size:3.20vw;
top:2.67vw;
left:2.67vw;
font-weight:bold;

}
}.pl-PL{
.u_c_L26018.normal{
position:relative;

}

.u_c_L26018.normal .step{
font-size:3.20vw;
color:#707070;

}

.u_c_L26018.normal .step-img{
display:block;
margin:2.00vw auto 5.33vw;
max-width:100%;
border:1.33vw solid white;
box-shadow:0px 2px 5px rgba(0,0,0,0.4);

}
}.pl-PL{
.u_c_TUAY19.normal{
position:relative;

}
}.pl-PL{
.u_c_K0IK20.normal{
position:relative;

}
}.pl-PL{
.u_c_FAAB22.normal{
position:relative;

}
}.pl-PL{
.u_c_OAV423.normal{
position:relative;

}
}.pl-PL{
.u_c_F6N624.normal{
position:relative;

}
}.pl-PL{
.u_c_OPMA26.normal{
position:relative;

}
}.pl-PL{
.u_c_MMUV27.normal{
position:relative;
width:100%;

}
}.pl-PL{
.u_c_EK0K28.normal{
position:absolute;
font-size:3.47vw;
color:#444;
bottom:6.00vw;
left:12.80vw;
font-weight:bold;

}
}.pl-PL{
.u_c_OXQE30.normal{
position:relative;

}
}.pl-PL{
.u_c_K8EC31.normal{
position:relative;

}
}.pl-PL{
.u_c_IPV333.normal{
position:relative;
width:100%;
background-color:white;

}
}.pl-PL{
.u_c_K0GA34.normal{
position:relative;
width:100%;

}
}.pl-PL{
.u_c_OQIZ35.normal{
position:absolute;
font-size:3.20vw;
top:2.67vw;
left:2.67vw;
font-weight:bold;

}
}.id-ID{
.u_c_L26018.normal{
position:relative;

}

.u_c_L26018.normal .step{
font-size:3.20vw;
color:#707070;

}

.u_c_L26018.normal .step-img{
display:block;
margin:2.00vw auto 5.33vw;
max-width:100%;
border:1.33vw solid white;
box-shadow:0px 2px 5px rgba(0,0,0,0.4);

}
}.id-ID{
.u_c_TUAY19.normal{
position:relative;

}
}.id-ID{
.u_c_K0IK20.normal{
position:relative;

}
}.id-ID{
.u_c_FAAB22.normal{
position:relative;

}
}.id-ID{
.u_c_OAV423.normal{
position:relative;

}
}.id-ID{
.u_c_F6N624.normal{
position:relative;

}
}.id-ID{
.u_c_OPMA26.normal{
position:relative;

}
}.id-ID{
.u_c_MMUV27.normal{
position:relative;
width:100%;

}
}.id-ID{
.u_c_EK0K28.normal{
position:absolute;
font-size:3.47vw;
color:#444;
bottom:6.00vw;
left:12.80vw;
font-weight:bold;

}
}.id-ID{
.u_c_OXQE30.normal{
position:relative;

}
}.id-ID{
.u_c_K8EC31.normal{
position:relative;

}
}.id-ID{
.u_c_IPV333.normal{
position:relative;
width:100%;
background-color:white;

}
}.id-ID{
.u_c_K0GA34.normal{
position:relative;
width:100%;

}
}.id-ID{
.u_c_OQIZ35.normal{
position:absolute;
font-size:3.20vw;
top:2.67vw;
left:2.67vw;
font-weight:bold;

}
}.ar-SA{
.u_c_L26018.normal{
position:relative;

}

.u_c_L26018.normal .step{
font-size:3.20vw;
color:#707070;

}

.u_c_L26018.normal .step-img{
display:block;
margin:2.00vw auto 5.33vw;
max-width:100%;
border:1.33vw solid white;
box-shadow:0px 2px 5px rgba(0,0,0,0.4);

}
}.ar-SA{
.u_c_TUAY19.normal{
position:relative;

}
}.ar-SA{
.u_c_K0IK20.normal{
position:relative;

}
}.ar-SA{
.u_c_FAAB22.normal{
position:relative;

}
}.ar-SA{
.u_c_OAV423.normal{
position:relative;

}
}.ar-SA{
.u_c_F6N624.normal{
position:relative;

}
}.ar-SA{
.u_c_OPMA26.normal{
position:relative;

}
}.ar-SA{
.u_c_MMUV27.normal{
position:relative;
width:100%;

}
}.ar-SA{
.u_c_EK0K28.normal{
position:absolute;
font-size:3.47vw;
color:#444;
bottom:6.00vw;
left:12.80vw;
font-weight:bold;

}
}.ar-SA{
.u_c_OXQE30.normal{
position:relative;

}
}.ar-SA{
.u_c_K8EC31.normal{
position:relative;

}
}.ar-SA{
.u_c_IPV333.normal{
position:relative;
width:100%;
background-color:white;

}
}.ar-SA{
.u_c_K0GA34.normal{
position:relative;
width:100%;

}
}.ar-SA{
.u_c_OQIZ35.normal{
position:absolute;
font-size:3.20vw;
top:2.67vw;
left:2.67vw;
font-weight:bold;

}
}
</style>
